import { render, staticRenderFns } from "./RenderTextAsTemplate.vue?vue&type=template&id=0ce9ddca&"
import script from "./RenderTextAsTemplate.vue?vue&type=script&lang=js&"
export * from "./RenderTextAsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports